import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, withApollo } from 'react-apollo';
import compose from 'lodash.flowright';
import { useHistory } from 'react-router-dom';

import withModal from '../../../../../components/global/modal/withModal';
import { getErrorString } from '../../../../../util/normalize-errors';
import Logo from '../../../../../components/global/Logo';
import { accountUpdate as accountUpdateMutation } from '../../../../../graphql/mutations/account';
import Button from '../../../../../components/global/Button';
import AccountSetupForm from '../../../views/Account/AccountSetup/components/AccountSetupForm';

export const ACCOUNT_SETUP_MODAL = 'modal/ACCOUNT_SETUP';

const propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  accountUpdate: PropTypes.func.isRequired,
  onAccountSetupComplete: PropTypes.func.isRequired,
  onCancelAccountSetup: PropTypes.func.isRequired,
};

const AccountSetupModal = ({
  user,
  accountUpdate,
  onAccountSetupComplete,
  onCancelAccountSetup,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const history = useHistory();

  const onSubmit = async data => {
    setSubmitting(true);
    setSubmitError('');

    const { name } = data;

    try {
      await accountUpdate({
        id: user.id,
        name,
      });

      onAccountSetupComplete();
    } catch (error) {
      setSubmitError(getErrorString(error));
      setSubmitting(false);
    }
  };

  if (!user) {
    return null;
  }

  return (
    <Fragment>
      <Logo imageProps={{ height: '50px' }} iconOnly className="mb-3" />

      <h2 className="my-1">Let&rsquo;s complete your profile!</h2>
      <div className="mb-4">Please provide your name below.</div>
      <AccountSetupForm
        account={user}
        onFormSubmit={onSubmit}
        submitError={submitError}
        submitting={submitting}
        skipUsername
      >
        {({ handleSubmit }) => (
          <Fragment>
            <div className="mt-4 d-flex">
              <Button
                onClick={event => {
                  event.preventDefault();
                  if (onCancelAccountSetup) {
                    onCancelAccountSetup();
                  } else {
                    history.goBack();
                  }
                }}
                btnStyle="secondary"
                disabled={submitting}
                className="ml-auto"
              >
                Go back
              </Button>
              <Button
                onClick={handleSubmit}
                disabled={submitting}
                className="ml-1"
              >
                {submitting ? 'Loading…' : 'Update account'}
              </Button>
            </div>
          </Fragment>
        )}
      </AccountSetupForm>
    </Fragment>
  );
};

AccountSetupModal.propTypes = propTypes;

const withAccountUpdateMutation = graphql(accountUpdateMutation, {
  props: ({ mutate }) => ({
    accountUpdate: account =>
      mutate({
        variables: {
          input: account,
        },
      }),
  }),
});

export { AccountSetupModal as AccountSetupModalComponent };

export default withModal(
  compose(withApollo, withAccountUpdateMutation)(AccountSetupModal),
  {
    name: ACCOUNT_SETUP_MODAL,
    hideHeader: true,
    dismissible: false,
    size: 'sm',
  },
);
